<template>
    <div>
        <b-alert variant="success" show v-if="complete">
            Your ID has been uploaded successfully. Please allow up to 48 hours
            for verification, we'll email you with an update as soon as
            possible.
        </b-alert>
        <b-alert variant="warning" show v-else>
            Please upload a photo of both sides of your identification. This can
            be a passport, drivers license, or national ID card.
        </b-alert>
        <div class="border p-3 bg-white text-left rounded mt-3">
            <h5>
                <font-awesome-icon
                    v-if="frontComplete"
                    icon="fa-light fa-check-circle"
                    class="text-success"
                />
                <font-awesome-icon v-else icon="fa-solid fa-circle" />
                Photo ID (Front)
            </h5>
            <div class="my-3">
                Upload a clear photo of the front of your ID, with all details
                visible
            </div>
            <onboarding-document-upload
                v-if="!frontComplete"
                @complete="frontComplete = true"
                type="idFront"
            >
                <font-awesome-icon icon="fa-duotone fa-cloud-arrow-up" />
                Upload
            </onboarding-document-upload>
        </div>

        <div class="border p-3 bg-white text-left rounded mt-3">
            <h5>
                <font-awesome-icon
                    v-if="backComplete"
                    icon="fa-light fa-check-circle"
                    class="text-success"
                />
                <font-awesome-icon v-else icon="fa-solid fa-circle" />
                Photo ID (Back)
            </h5>
            <div class="my-3">
                Upload a clear photo of the back of your ID, with all details
                visible
            </div>
            <onboarding-document-upload
                v-if="!backComplete"
                @complete="backComplete = true"
                type="idBack"
            >
                <font-awesome-icon icon="fa-duotone fa-cloud-arrow-up" />
                Upload
            </onboarding-document-upload>
        </div>
    </div>
</template>


<script>
import OnboardingDocumentUpload from "@/components/onboarding/document/OnboardingDocumentUpload";

export default {
    data() {
        return {
            frontComplete: false,
            backComplete: false,
        };
    },
    computed: {
        complete() {
            return this.frontComplete && this.backComplete;
        },
    },
    components: {
        OnboardingDocumentUpload,
    },
};
</script>